/* =====================================================================================
   FARB-OPTIONEN (ollihess, custom)

   1) Dot-Sync: Impacts x-listbox schreibt bei Auswahl NUR textContent ins aria-owns-Ziel
      des Select-Buttons. Der Farbpunkt liegt deshalb als eigenes [data-dot-slot]-Element
      vor dem Wert-Span (variant-picker.liquid) und wird hier beim listbox:change-Event
      aus der gewaehlten Option nachgezogen.

   2) <wish-color>: Farbwahl-Popup mit Pflicht vor dem ATC. Zwei Betriebsarten:
      a) Mit option-position (Wunschfarbe-Variante, variant-picker.liquid): hoert auf
         variant:change am product-form; beim Wechsel AUF den Options-Wert "wunschfarbe"
         erscheint die Bar und der Drawer oeffnet sich.
      b) Ohne option-position (Mallet-Set-Farbwahl, oh-mallet-color.liquid): Bar ist
         immer sichtbar, die Wahl ist immer Pflicht.
      Die Auswahl landet im Line-Item-Property-Input (disabled solange leer, damit nichts
      Leeres submitted wird). Ein capture-Submit-Guard faengt den ATC ab, bis eine Farbe
      gewaehlt ist (capture am document laeuft VOR Impacts submit-Handler auf dem
      product-form); dabei werden Fehlertext ([data-wish-error]) und Drawer gezeigt.
      label-prefix steuert den Trigger-Text nach der Wahl ("<prefix>: <farbe>").
      Grenze: Shopifys Dynamic-Checkout-Button (Direkt kaufen) und Quick-Buy von
      Produktkarten feuern kein submit-Event, dort greift der Zwang nicht.

   3) Kachel-Sync: Impacts "variant_image"-Darstellung rendert pro Optionswert das
      Foto von value.variant. Serverseitig passt das zur initialen Auswahl, beim
      Optionswechsel tauscht Impacts VariantPicker die Bilder aber nie aus. Hier
      werden sie bei variant:change nachgezogen: pro Kachel die Variante suchen,
      die der aktuellen Auswahl mit ausgetauschtem Optionswert entspricht, und
      deren featured_image einsetzen (move line: Farbe schwarz, also zeigen die
      Durchmesser-Kacheln die schwarzen Mallets). Kacheln ohne passende Variante
      oder ohne Foto behalten ihr Bild.
   ===================================================================================== */
(function () {
  document.addEventListener('listbox:change', function (event) {
    var option = event.target;
    if (!option || !option.closest) return;
    var listbox = option.closest('x-listbox');
    var owns = listbox && listbox.getAttribute('aria-owns');
    if (!owns) return;
    owns.split(' ').forEach(function (id) {
      var valueEl = document.getElementById(id);
      var slot = valueEl && valueEl.parentElement && valueEl.parentElement.querySelector('[data-dot-slot]');
      if (!slot) return;
      var dot = option.querySelector('.oh-color-dot');
      if (dot) {
        slot.replaceChildren(dot.cloneNode(true));
      } else {
        slot.replaceChildren();
      }
    });
  });

  function sizedImageUrl(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  document.addEventListener('variant:change', function (event) {
    var form = event.target;
    var product = event.detail && event.detail.product;
    var variant = event.detail && event.detail.variant;
    if (!form || !form.id || !product || !variant || !Array.isArray(product.variants)) return;

    document.querySelectorAll('variant-picker[form="' + CSS.escape(form.id) + '"]').forEach(function (picker) {
      picker.querySelectorAll('input[type="radio"][name^="option"]').forEach(function (input) {
        var img = picker.querySelector('label[for="' + CSS.escape(input.id) + '"] img');
        if (!img) return;

        var optionIndex = parseInt(input.name.replace('option', ''), 10) - 1;
        var target = product.variants.find(function (candidate) {
          return candidate.options.every(function (value, index) {
            return index === optionIndex ? value === input.value : value === variant.options[index];
          });
        });

        var image = target && target.featured_image;
        if (!image || !image.src || img.getAttribute('data-oh-thumb-src') === image.src) return;

        img.setAttribute('data-oh-thumb-src', image.src);
        img.src = sizedImageUrl(image.src, 120);
        img.srcset = sizedImageUrl(image.src, 60) + ' 60w, ' + sizedImageUrl(image.src, 120) + ' 120w';
        if (typeof image.alt === 'string') img.alt = image.alt;
      });
    });
  });

  class WishColor extends HTMLElement {
    connectedCallback() {
      this._input = this.querySelector('[data-wish-input]');
      this._bar = this.querySelector('[data-wish-bar]');
      this._label = this.querySelector('[data-wish-label]');
      this._dotSlot = this.querySelector('[data-wish-dot]');
      this._error = this.querySelector('[data-wish-error]');
      this._trigger = this.querySelector('.oh-wishcolor__trigger');
      if (!this._input || !this._bar) return;

      this._defaultLabel = this._label ? this._label.textContent : '';
      this._defaultDotNode = this._dotSlot && this._dotSlot.firstElementChild
        ? this._dotSlot.firstElementChild.cloneNode(true)
        : null;
      this._labelPrefix = this.getAttribute('label-prefix') || 'Wunschfarbe';
      this._optionIndex = parseInt(this.getAttribute('option-position'), 10) - 1;
      this._abort = new AbortController();
      var signal = this._abort.signal;

      this.querySelectorAll('[data-wish-value]').forEach(function (btn) {
        btn.addEventListener('click', this._onPick.bind(this), { signal: signal });
      }, this);

      var form = document.forms[this.getAttribute('form')];
      if (form) {
        if (!Number.isNaN(this._optionIndex)) {
          form.addEventListener('variant:change', this._onVariantChange.bind(this), { signal: signal });
        }
        document.addEventListener('submit', function (event) {
          if (event.target === form && this.needsChoice) {
            event.preventDefault();
            event.stopPropagation();
            this._setError(true);
            this._openDrawer();
          }
        }.bind(this), { capture: true, signal: signal });
      }
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
    }

    get active() {
      return !this._bar.hidden;
    }

    get needsChoice() {
      return this.active && this._input.disabled;
    }

    _drawer() {
      return document.getElementById(this.getAttribute('drawer'));
    }

    _setError(show) {
      if (this._error) {
        this._error.hidden = !show;
        if (show) {
          this._error.setAttribute('role', 'alert');
        } else {
          this._error.removeAttribute('role');
        }
      }
      if (this._trigger) {
        this._trigger.classList.toggle('oh-wishcolor__trigger--error', show);
      }
    }

    _openDrawer() {
      var drawer = this._drawer();
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }

    _onVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !Array.isArray(variant.options)) return;
      var value = String(variant.options[this._optionIndex] || '').toLowerCase().trim();
      if (value === 'wunschfarbe') {
        if (!this.active) {
          this._bar.hidden = false;
          if (this._input.disabled) this._openDrawer();
        }
      } else if (this.active) {
        this._bar.hidden = true;
        this._reset();
      }
    }

    _onPick(event) {
      var btn = event.currentTarget;
      var name = btn.getAttribute('data-wish-value');
      this._input.value = name;
      this._input.disabled = false;
      this.querySelectorAll('[data-wish-value]').forEach(function (other) {
        other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
      });
      if (this._label) this._label.textContent = this._labelPrefix + ': ' + name;
      if (this._dotSlot) {
        var dot = btn.querySelector('.oh-color-dot');
        var replacement = dot ? dot.cloneNode(true) : this._defaultDotNode;
        if (replacement) {
          this._dotSlot.replaceChildren(replacement.cloneNode(true));
        }
      }
      this._setError(false);
      var drawer = this._drawer();
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
    }

    _reset() {
      this._input.value = '';
      this._input.disabled = true;
      this.querySelectorAll('[data-wish-value]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
      });
      if (this._label) this._label.textContent = this._defaultLabel;
      if (this._dotSlot && this._defaultDotNode) {
        this._dotSlot.replaceChildren(this._defaultDotNode.cloneNode(true));
      }
      this._setError(false);
    }
  }

  if (!window.customElements.get('wish-color')) {
    window.customElements.define('wish-color', WishColor);
  }
})();
